var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoDataRead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 85 42",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "SI_4L_fill_red",
    d: "M35.9 29.8l10.3-10.3c.7-.7 1.8-.7 2.4 0l.4.4c.7.7.7 1.8 0 2.4L38.8 32.6c-.7.7-1.8.7-2.4 0l-.4-.4c-.7-.6-.7-1.7-.1-2.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "SI_4L_fill_red",
    d: "M46.2 32.6L35.9 22.3c-.7-.7-.7-1.8 0-2.4l.4-.4c.7-.7 1.8-.7 2.4 0L49 29.8c.7.7.7 1.8 0 2.4l-.4.4c-.6.7-1.7.7-2.4 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "SI_4L_stroke",
    d: "M29.5 4.7h15.9l10.1 9.1v23.9h-26z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "SI_4L_stroke",
    d: "M45.2 5.2v9h10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataRead);
export default __webpack_public_path__ + "static/media/noDataRead.6ba727939fb97c71b4ca2278c9618a40.svg";
export { ForwardRef as ReactComponent };